<template>
  <div>
    <h1>Admin</h1>
    <VAsync :await="request">
      <template #resolved>
        <h2>Users</h2>
        <VTable
          :headers="Object.keys(users[0]).map((key) => ({ key }))"
          :items="users"
        />

        <h2>Plaid</h2>
        <VTable
          :headers="Object.keys(plaid[0]).map((key) => ({ key }))"
          :items="plaid"
        />
      </template>
    </VAsync>
  </div>
</template>

<script>
// @ts-check
import { API } from "../config"
import http from "../perxHttp"

export default {
  data: () => ({
    request: null,
    users: null,
    usernames: null,
    emails: null,
    plaid: null,
  }),

  mounted() {
    this.request = http
      .get(`${API}/admin`)
      .then(({ users, usernames, emails, plaid }) => {
        this.users = users
        this.usernames = usernames
        this.emails = emails
        this.plaid = plaid
      })
  },
}
</script>

